import $state from '../download-state.js'
import Api from '~/store/idonia-api/api.js'
import store from '~/store/store'
import useLanguageTree from '~/commons/language'
const {t} = useLanguageTree()

export default function (payload) {
  return new Promise((resolve, reject) => {
    if (payload.endpoint) {
      payload.request = () => {
        const { promise, xhr } = Api.downloadBlobCancelable(payload.endpoint, {
          headers: this.$route.params.sha
            ? { Authorization: store.getters['session/guestAuthentication'][this.$route.params.sha] }
            : {},
          fileName: payload.file ? payload.file.name : undefined,
          onProgress: (e) => {
            if (e.lengthComputable) {
              const progress = Math.round((e.loaded / e.total) * 100)
              $state.updateFileProgress(payload.file.fileID, progress)
            }
          }
        })
        $state.updateFileXHR(payload.file.fileID, xhr)
        return promise
      }
      payload.uuid = payload.file.fileID
      $state.addFile(payload).then(() => {
        resolve(payload.uuid)
      })
    } else {
      // Check if already downloading
      if ($state.isDownloading) {
        store.dispatch('dialog/unshiftDialog', {
          title: t('warningDownloadInProgressTitle'),
          body: t('warningDownloadInProgress'),
          persistent: true,
          width: 480,
          actions: {
            accept: {
              title: 'Close',
              callback: () => {
                store.dispatch('dialog/clearQueue')
              }
            }
          }
        })

        reject(new Error('Download already in progress'))
        return
      }

      $state.isDownloading = true
      Api.get('file/' + payload.file.fileID + '/zip', {
        os: payload.file.os || '',
        arch: payload.file.arch || '',
        excludeViewer: payload.file.excludeViewer,
        sdl: payload.file.sdl || '',
        includeRenderedImages: payload.file.includeRenderedImages || ''
      }, response => {
        console.log(response)
        payload.uuid = response.body.task_id
        $state.addFile(payload).then(() => {
          resolve(payload.uuid)
        })
      }, (e) => {
        console.log('error:', e)
        reject(e)
        if (e.status === 406) {
          store.dispatch('dialog/unshiftDialog', {
            title: t('NoDownloadableTitle'),
            body: require('~/components/common/dialog/types/DialogNoDownloadable.vue').default,
            persistent: true,
            props: {'limits': e.body.limits, description: e.body.description},
            width: 480,
            actions: {
              accept: {
                title: 'Close',
                callback: () => {
                  store.dispatch('dialog/clearQueue') // TODO give all dialogs an id and filter this kind of operations¿?
                }
              }
            }
          })
        }
      }, false, payload.headers)
    }
  }).catch(e => {
    console.error(e)
  }).finally(async() => {
    await new Promise(resolve => setTimeout(resolve, 500)).then(() => {
      $state.isDownloading = false
    })
  })
}

export function zipFiles (files, excludeViewer, includeRenderedImages) {
  return new Promise((resolve, reject) => {
    const date = new Date().toLocaleString().split(',')[0]
    const name = t('file') + '-' + date.replaceAll('/', '')
    Api.postV2('files/zip', {
      data: {
        files: files,
        zip_name: name,
        exclude_viewer: excludeViewer,
        includeRenderedImages: includeRenderedImages || ''
      }
    })
    .then(response => {
      console.log(response)
      let payload = {
        uuid: response.body.task_id,
        file: {
          name: name + '.zip',
          zipFileIDs: files,
          excludeViewer: excludeViewer,
          includeRenderedImages: includeRenderedImages
        }
      }
      $state.addFile(payload).then(() => {
        resolve(payload.uuid)
      })
    })
    .catch((e) => {
      console.log('error:', e)
      if (e.status === 406) {
        store.dispatch('dialog/unshiftDialog', {
          title: t('NoDownloadableTitle'),
          body: require('~/components/common/dialog/types/DialogNoDownloadable.vue').default,
          persistent: true,
          props: {'limits': e.body.limits, description: e.body.description},
          width: 480,
          actions: {
            accept: {
              title: 'Close',
              callback: () => {
                store.dispatch('dialog/clearQueue') // TODO give all dialogs an id and filter this kind of operations¿?
              }
            }
          }
        })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/plugins/uploader/methods/download.js